const initNoveltiesInfiniteSlider = () => {
  const root = document.querySelector('[data-novelties-infinite-container]');
  if (!root) {
    return;
  }

  const container = root.querySelector('[data-novelties-infinite-swiper]');
  if (!container) {
    return;
  }

  const tabs = root.querySelectorAll('[data-novelties-infinite-tab]');
  const pagination = root.querySelector('[data-novelties-infinite-pagination]');

  const setActiveTab = (category) => {
    tabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.category === category);
    });
  };

  const swiper = new window.Swiper(container, {
    slidesPerView: 2,
    slidesPerGroup: 2,
    speed: 500,
    spaceBetween: 10,
    grabCursor: true,
    watchOverflow: true,
    resistanceRatio: 0.85,
    navigation: {
      prevEl: root.querySelector('[data-slider-prev]'),
      nextEl: root.querySelector('[data-slider-next]'),
    },
    pagination: pagination ? {el: pagination, clickable: true} : false,
    breakpoints: {
      808: {slidesPerView: 3, spaceBetween: 20},
      1200: {slidesPerView: 5},
    },
  });

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const {category} = tab.dataset;
      const index = [...swiper.slides].findIndex((slide) => slide.dataset.category === category);

      setActiveTab(category);
      swiper.slideTo(Math.max(index, 0));
    });
  });

  swiper.on('slideChangeTransitionEnd', () => {
    const lastVisible = Math.min(
        swiper.activeIndex + Math.ceil(swiper.params.slidesPerView) - 1,
        swiper.slides.length - 1
    );
    const slide = swiper.slides[lastVisible];
    const category = slide && slide.dataset.category;

    if (category) {
      setActiveTab(category);
    }
  });
};

export {initNoveltiesInfiniteSlider};
